export const stockMovementValue = (item, delta) => {
  const cost = item?.unitCost;
  if (cost == null || cost === '' || !Number.isFinite(Number(cost)) || Number(cost) < 0) return { unitCost: null, value: null };
  return { unitCost: Number(cost), value: Math.sign(delta) * Math.round((Math.abs(Number(delta) * Number(cost)) + Number.EPSILON) * 100) / 100 };
};
export const formatStockMoney = value => value == null ? '—' : `${Number(value).toFixed(2)} €`;
